module.exports = __webpack_public_path__ + "static/media/envelopDark.73ab75c7.svg";